import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { InviteStatusType } from ".";
import React, { useState } from "react";
import { blue, deepOrange } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import { handleSendReferralEmail } from "../../../utils/apis/referrals";
import { toast } from "react-toastify";
import InviteFriendIcon from "../../../svg/Profilenavicons/InviteFriendIcon";
import InviteSentIcon from "../../../svg/ReferralIcons/InviteSentIcon";
import ChatsIcon from "../../../svg/ChatsIcon";
import ProfileIcon from "../../../svg/Profilenavicons/ProfileIcon";
interface FriendDetailProps {
  email: string;
  inviteStatus: InviteStatusType;
}

const FriendDetail: React.FC<FriendDetailProps> = (props) => {
  const { email, inviteStatus } = props;
  const navigate = useNavigate();
  const { authUser } = useAuth();
  const theme = useTheme();
  const [ hasResentInvite, setHasResentInvite ] = useState<boolean>(false);

  const handleResendInvite = async () => {
    if (!hasResentInvite) {
      handleSendReferralEmail(authUser, email, null, toast, null)
      setHasResentInvite(true);
    } else {
      toast.error("Invite already resent, try again later");
    }
  }

  const StatusText: React.FC = () => {
    switch (inviteStatus?.status) {
      case "pending":
        return (
          <Typography variant='body2' color={deepOrange[400]}>
            Pending
          </Typography>
        )
      case "account_created":
        return (
          <Typography variant='body2' color={blue[400]}>
            Account Created
          </Typography>
        )
      case "persona_created":
        return (
          <Typography variant="body2" color='#0810FF'>
            AI Persona Created
          </Typography>
        )
      default:
        return (
          <Typography variant='body2' color={deepOrange[400]}>
            Pending
          </Typography>
        )
    }
  }

  const StatusButton: React.FC = () => {
    switch (inviteStatus?.status) {
      case "pending":
        return (
          <Button
            variant='contained'
            size='medium'
            disabled={hasResentInvite}
            sx={{
              flexShrink: 0,
              stroke: (theme) => hasResentInvite ?
                theme.palette.text.disabled :
                theme.palette.primary.contrastText,
            }}
            onClick={() => {
              handleResendInvite();
            }}
            startIcon={<InviteSentIcon stroke='inherit' width="19" height="19"/>}
          >
            Resend
          </Button>
        )
      case "account_created":
        return (
          <Button
            href={`/${inviteStatus?.userName}`}
            variant='outlined'
            color='secondary'
            size='medium'
            sx={{
              flexShrink: 0,
            }}
            onClick={(e) => {
              e.preventDefault();
              if (inviteStatus.userName) navigate(`/${inviteStatus.userName}`)
            }}
            startIcon={<ProfileIcon color={theme.palette.primary.main}/>}
          >
            View Profile
          </Button>
        )
      case "persona_created":
        return (
          <Button
            href={`/${inviteStatus?.userName}/chat`}
            variant='outlined'
            color='secondary'
            size='medium'
            sx={{
              flexShrink: 0,
              stroke: (theme) => theme.palette.primary.main,
            }}
            onClick={(e) => {
              e.preventDefault();
              if (inviteStatus.userName) navigate(`/${inviteStatus.userName}/chat`)
            }}
            startIcon={<ChatsIcon width="19" height="19" stroke="inherit"/>}
          >
            Chat
          </Button>
        )
      default:
        return (
          <Button
            variant='outlined'
            color='secondary'
            size='medium'
            disabled={hasResentInvite}
            sx={{
              flexShrink: 0,
              stroke: (theme) => hasResentInvite ?
                theme.palette.text.disabled :
                theme.palette.primary.contrastText,
            }}
            onClick={() => {
              handleResendInvite();
            }}
            startIcon={<InviteSentIcon stroke='inherit' width="19" height="19"/>}
          >
            Resend
          </Button>
        )
    }
  }

  return (
    <Box
      sx={{
        px: 1.5,
        py: 1,
        backgroundColor: (theme) => theme.palette.background["paper-elevation-7"],
        gap: 3.75,
        display: "flex",
        alignItems: "center",
        borderRadius: (theme) => theme.shape.borderRadiusMd,
        width: "100%",
        maxWidth: "100%",
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
      >
        <Typography variant='body2' color='text.secondary' noWrap textOverflow={"ellipsis"} sx={{maxWidth: '100%'}}>
          {email}
        </Typography>
        <StatusText />
      </Box>
      <StatusButton />
    </Box>
  )
}

export default FriendDetail;
